/* eslint-disable */
import React, {useState, useEffect} from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { quizService } from '../../api/quizService';
import './Checkout.css';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CheckoutForm, {getLocalCheckoutData} from "./components/CheckoutForm";
import {paymentService} from "../../api/paymentService";
import CheckoutTitleWidget from "./components/CheckoutTitleWidget/CheckoutTitleWidget";
import ScrollToTop from "./components/ScrollToTop";
import Spinner from "./components/Spinner";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

const Checkout = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { funnelId} = useParams<{ funnelId: string; version: string }>();

  // Get data from location.state or fallback to localStorage
  const savedCheckoutData = getLocalCheckoutData();
  const priceId = location.state?.priceId || savedCheckoutData?.priceId;
  const productId = location.state?.productId || savedCheckoutData?.productId;
  const isSingle = location.state?.isSingle || savedCheckoutData?.isSingle;
  const [price, setPrice] = useState<any>(null);
  const [secondPrice, setSecondPrice] = useState<any>(null);
  const [coupon, setCoupon] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [paymentIntent, setPaymentIntent] = useState<any>(null)

  const handleCurrencyClick = () => {
    // For now, keep USD as the only option
    // Future implementation: show dropdown with currency options
    console.log('Currency dropdown clicked - USD only for now');
  };

  // Scroll to top when component mounts and after content loads
  useEffect(() => {
    // Immediate scroll to top
    window.scrollTo(0, 0);

    // Additional scroll after a delay to handle layout shifts
    const scrollTimer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);

    // Force scroll to top if content shifts the layout
    const handleLayoutShift = () => {
      if (window.scrollY > 50) {
        window.scrollTo(0, 0);
      }
    };

    if (!localStorage.getItem('emailAddress')) {
      navigate('/quiz/f1/1/v1');
    }

    // Monitor for layout shifts in the first 2 seconds
    const layoutShiftTimer = setTimeout(() => {
      const interval = setInterval(() => {
        handleLayoutShift();
      }, 100);

      // Clean up after 2 seconds
      setTimeout(() => {
        clearInterval(interval);
      }, 2000);
    }, 100);

    createPaymentIntent()


    return () => {
      clearTimeout(scrollTimer);
      clearTimeout(layoutShiftTimer);
    };
  }, []); // Run only once when component mounts

  // Additional scroll to top when loading state changes
  useEffect(() => {
    if (!loading) {
      // Small delay to ensure content is rendered
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);
    }
  }, [loading]);

  useEffect(() => {
    const fetchPriceAndCoupon = async () => {
      try {
        if (!productId) throw new Error('No product ID');

        const funnelVersion = funnelId?.replace('f', '')
        // Fetch price data
        const response = await quizService.getProductPrices(funnelVersion || '1');
        const prices = response?.prices?.data || [];
        const firstPrice = prices.find((p: any) => p.id === priceId);
        const secondPrice = prices.find((p: any) => p.id !== priceId);
        setPrice(firstPrice);
        setSecondPrice(secondPrice)

        // Fetch coupon data
        try {
          const couponResponse = await quizService.getCouponByProductId(productId);
          if (couponResponse && couponResponse.coupons && couponResponse.coupons.data && couponResponse.coupons.data.length > 0) {
            setCoupon(couponResponse.coupons.data[0]);
          }
        } catch (couponError) {
          // Coupon fetch failed, but continue without coupon
          console.log('No coupon available');
        }
      } catch (e) {
        setError('Failed to load price');
      } finally {
        setLoading(false);
        // Ensure scroll to top after data loads
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
      }
    };
    if (priceId && productId) fetchPriceAndCoupon();
    }, [priceId, productId]);

  const createPaymentIntent = async () => {
    const funnelVersion = funnelId?.replace('f', '')
    const response = await quizService.getProductPrices(funnelVersion || '1');
    const prices = response?.prices?.data || [];
    console.log('prices', prices)
    const firstPrice = prices.find((p: any) => p.id === priceId);
    console.log('first price ', firstPrice)
    if(firstPrice?.currency !== 'jpy'){
      const result = await paymentService.createPaymentIntent(firstPrice.unit_amount, firstPrice.currency)
      setPaymentIntent(result)
    }
  }

  if (!priceId || !productId) {
    return <div className="checkout-bg"><div className="checkout-outer-card"><div className="checkout-card"><div className="checkout-title-row"><span className="checkout-title">{t('checkout.title')}</span></div><div className="checkout-total-row"><span className="checkout-total-label">Error:</span><span className="checkout-total-price">{t('checkout.errorNoPrice')}</span></div></div></div></div>;
  }

  if (loading) {
    return (
      <div className="checkout-bg">
              <Spinner />
      </div>
    );
  }

  if (error || !price) {
    return <div className="checkout-bg"><div className="checkout-outer-card"><div className="checkout-card"><div className="checkout-title-row"><span className="checkout-title">{t('checkout.title')}</span></div><div className="checkout-total-row"><span className="checkout-total-label">Error:</span><span className="checkout-total-price">{error || t('checkout.errorPriceNotFound')}</span></div></div></div></div>;
  }

  const originalPrice = price.currency === 'usd'  || price.currency === 'eur' ? price.unit_amount / 100 : price.unit_amount;
  let discountAmount = 0;
  let finalPrice = originalPrice;

  // Calculate discount if coupon is available
  if (coupon) {
    if (coupon.percent_off) {
      discountAmount = (originalPrice * coupon.percent_off) / 100;
    } else if (coupon.amount_off) {
      discountAmount = coupon.amount_off / 100; // Convert from cents to dollars
    }
    finalPrice = Math.max(0, originalPrice - discountAmount);
  }

  const formattedFinalPrice = finalPrice.toLocaleString('en-US', { style: 'currency', currency: price.currency?.toUpperCase?.() || 'USD' });

  const TRIAL_DAYS = 7;
  const getLocalizedIntervalLabel = (interval: string, count: number) => {
    const key = count > 1 ? `subscription.intervals.${interval}s` : `subscription.intervals.${interval}`;
    return t(key);
  };

  // Calculate subscription terms dynamically
  const getSubscriptionTerms = () => {
    if (!price) return { initialAmount: '$1.95',
      recurringAmount: '$29.99',
      interval: 'every 4 weeks',
      recurringInterval: '3 week',
      listPriceInterval: 7,
      listPriceIntervalName: 'day'
    };

    const originalAmount = price.currency === 'usd' || price.currency === 'eur' ? price.unit_amount / 100 : price.unit_amount;
    let discountedAmount = originalAmount;

    // Apply coupon discount
    if (coupon) {
      if (coupon.percent_off) {
        discountedAmount = originalAmount * (1 - coupon.percent_off / 100);
      } else if (coupon.amount_off) {
        discountedAmount = Math.max(0, originalAmount - (coupon.amount_off / 100));
      }
    }

    const currency = price.currency?.toUpperCase() || 'USD';
    const formatPrice = (amount: number) =>
      amount.toLocaleString('en-US', { style: 'currency', currency });

    // Format interval text
    let intervalText = '';
    if (price.recurring) {
      const { interval, interval_count } = price.recurring;
      if (interval_count === 1) {
        intervalText = `every ${interval}`;
      } else {
        intervalText = `every ${interval_count} ${interval}s`;
      }
    }
    const getLocalizedInterval = (interval: string, count: number) => {
      const key = count > 1 ? `subscription.intervals.${interval}s` : `subscription.intervals.${interval}`;
      return t(key);
    };

    let secondIntervalWithCount = '';
    let formattedSecondPrice = '';

      if(secondPrice) {
        const secondInterval = secondPrice.recurring?.interval || 'month';
        const secondIntervalCount = secondPrice.recurring?.interval_count || 1;
        const secondPriceNumber = secondPrice.currency === 'usd' || secondPrice.currency === 'eur' ? secondPrice.unit_amount / 100 : secondPrice.unit_amount;
        formattedSecondPrice = secondPriceNumber.toLocaleString('en-US', {
          style: 'currency',
          currency: secondPrice.currency.toUpperCase()
        });
        secondIntervalWithCount = `${secondIntervalCount} ${getLocalizedInterval(secondInterval, secondIntervalCount)}`;
      }

    return {
      initialAmount: formatPrice(discountedAmount),
      recurringAmount: formattedSecondPrice,
      interval: intervalText,
      recurringInterval: secondIntervalWithCount,
      discountPercent: coupon?.percent_off || null,
      listPriceInterval: price.recurring.interval_count || 7,
      listPriceIntervalName: price.recurring.interval || 'day'
    };
  };

  const subscriptionTerms = getSubscriptionTerms();

  let subs = null;
  if(paymentIntent){
    subs = paymentIntent?.subs;
  }

  return (
      <>
        <ScrollToTop />
        <div className="checkout-bg">
          <div className="checkout-outer-card">
            <div className="checkout-card">
              {!!isSingle ? <CheckoutTitleWidget title={t('checkout.title', {
                formattedFinalPrice: formattedFinalPrice,
                interval: `${TRIAL_DAYS} ${getLocalizedIntervalLabel('day', TRIAL_DAYS)}`,
              })} subtitle={t('checkout.subtitle')}/>:<CheckoutTitleWidget title={t('checkout.title', {
              formattedFinalPrice: formattedFinalPrice,
              interval: `${subscriptionTerms?.listPriceInterval} ${getLocalizedIntervalLabel(subscriptionTerms.listPriceIntervalName, subscriptionTerms.listPriceInterval)}`,
            })} subtitle={t('checkout.subtitle')}/>
              }
              {
                // subs !== null && subs?.client_secret &&
                  <Elements stripe={stripePromise} options={subs !== null && subs?.client_secret ? { clientSecret: subs.client_secret || ''}: {}}>
                    <CheckoutForm priceId={priceId}
                                  price={price} coupon={coupon}
                                  secondPrice={secondPrice}
                                  isSingle={isSingle}
                                  clientSecret={subs?.client_secret || ''}
                                  paymentIntentId={subs?.id || ''}
                    />
                  </Elements>
              }
            </div>
            <div className="checkout-divider" />
            <div className="checkout-terms-section">
              <div className='bottom-checkout'>
                <div className="checkout-terms-title">{t('checkout.moneyBackGuarantee')}</div>
                <div className="checkout-terms-text">
                  {t('checkout.moneyBackText')}
                </div>
                <div className="checkout-terms-title">{t('checkout.cancelAnytimeTitle')}</div>
                <div className="checkout-terms-text">
                  {t('checkout.cancelAnytimeText')}
                  <a href="/support" target={'_blank'} style={{textDecoration: 'underline'}}>{t('subscription.termsLink')}</a>.
                </div>
              </div>
              <div className="checkout-terms-title">{t('checkout.termsAndSubscription')}</div>
              {!!isSingle ?  <div className="checkout-terms-text">
                {t('subscription.checkoutRenewalMessage', {
                  formattedPrice: subscriptionTerms.initialAmount,
                  firstIntervalCount: `${TRIAL_DAYS} ${getLocalizedIntervalLabel('day', TRIAL_DAYS)}`
                })}
                {t('subscription.renewalMessageSecond', {
                  firstIntervalCount: `${TRIAL_DAYS} ${getLocalizedIntervalLabel('day', TRIAL_DAYS)}`,
                  formattedSecondPrice: subscriptionTerms.recurringAmount,
                  secondIntervalCount: subscriptionTerms.recurringInterval
                })} <a href="/subscription-terms" target={'_blank'} style={{textDecoration: 'underline'}}>{t('subscription.termsLinkList')}</a>.
              </div> :
                  <div className="checkout-terms-text">
                    {t('subscription.checkoutRenewalMessage', {
                      formattedPrice: subscriptionTerms.initialAmount,
                      firstIntervalCount: `${subscriptionTerms.listPriceInterval} ${getLocalizedIntervalLabel(subscriptionTerms.listPriceIntervalName, subscriptionTerms.listPriceInterval)}`
                    })}
                    {t('subscription.renewalMessageSecond', {
                      firstIntervalCount: `${subscriptionTerms.listPriceInterval} ${getLocalizedIntervalLabel(subscriptionTerms.listPriceIntervalName, subscriptionTerms.listPriceInterval)}`,
                      formattedSecondPrice: subscriptionTerms.initialAmount,
                      secondIntervalCount: `${subscriptionTerms.listPriceInterval} ${getLocalizedIntervalLabel(subscriptionTerms.listPriceIntervalName, subscriptionTerms.listPriceInterval)}`
                    })} <a href="/subscription-terms" target={'_blank'} style={{textDecoration: 'underline'}}>{t('subscription.termsLinkList')}</a>.
                  </div>
              }


            </div>
          </div>
        </div>
      </>
  );
};

export default Checkout;
